import { useMemo } from 'react';
import { useQuery } from '@common-fe/common-fe';

import { api } from '@/api';
import { OrganizationTypes } from '@/common/constants';
import { API_URL } from '@/dtos';
import { useCurrentOrganization } from '@/modules/core/hooks';

import { UndeliverableMailStatisticPayload } from '../UndeliverableMailStatistic.types';

const QUERY_KEY = 'GET_UNDELIVERABLE_MAIL_STATISTIC';

const useGetUndeliverableMailStatisticQuery = () => {
  const {
    observingOrganization: { type, id },
  } = useCurrentOrganization();

  const isSystemLevel = useMemo(() => type === OrganizationTypes.system, [type]);

  const { isLoading, data, isSuccess } = useQuery(
    [QUERY_KEY, type, id],
    () => api.get(API_URL.METRICS_UNDELIVERABLE_MAIL),
    {
      enabled: !isSystemLevel,
    }
  );

  const formattedData = useMemo<UndeliverableMailStatisticPayload | null>(() => {
    const responseData = data?.data;

    if (responseData) {
      return {
        flaggedEmployeesCount: responseData?.flagged_employees_count || 0,
      };
    }

    return null;
  }, [data?.data]);

  const isEmpty = useMemo(() => {
    if (isSystemLevel) {
      return true;
    }
    return false;
  }, [isSystemLevel]);

  return {
    isLoading,
    isEmpty,
    isSuccess,
    data: formattedData,
  };
};

export default useGetUndeliverableMailStatisticQuery;
